/* global Promise */
import { makeAPICall } from "./core";
import axios from "axios";
import { normalizeError, logError } from "./errorHandling";

export const getCookie = (name) => {
  // There are allowed regex characters allowed within cookie names,
  // replace them if there is overlap.
  const escapedName = name.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
  const cookieRegex = new RegExp(`(?:^|; )${escapedName}=([^;]*)`);
  const match = document.cookie.match(cookieRegex);

  return match ? decodeURIComponent(match[1]) : null;
};

const axiosInstance = axios.create(
  {
    baseURL: "/api",
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRFTOKEN': getCookie("csrftoken"),
    },
    maxRedirects: 0,
  }
);

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    logError(error, 'TEVService');
    return Promise.reject(normalizeError(error));
  }
);

// Add request interceptor to update CSRF token
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers['X-CSRFTOKEN'] = getCookie("csrftoken");
    return config;
  },
  (error) => Promise.reject(error)
);

export const TEVService = axiosInstance;

// Legacy helper function - deprecated
const makePostPayload = (data) => {
  console.warn('makePostPayload is deprecated. Use data directly with TEVService.');
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
};

export const fetchUserContext = () => {
  return TEVService.get("/users/current_user/");
};

// Legacy authentication functions - deprecated
// Use TEVService.post("/login/", data) directly instead
export const attemptLogin = (formData, navigation) => {
  console.warn('attemptLogin is deprecated. Use TEVService.post("/login/", data) directly.');
  const url = "/login/";
  const payload = makePostPayload(formData);

  return TEVService
    .post(url, payload)
    .then(() => navigation("/"));
};

// Legacy logout function - deprecated
// Use TEVService.post("/logout/", {}) with window.location.reload() instead
export const attemptLogout = (navigation) => {
  console.warn('attemptLogout is deprecated. Use TEVService.post("/logout/", {}) with window.location.reload() instead.');
  const url = "/logout/";
  return TEVService
    .post(url, {})
    .then(() => navigation("/"));
};


export const fetchData = (url, callback) => {
  return makeAPICall(url).then(response => response.json()).then(json => callback(json));
};


export const resourceTypeFormatting = (resourceType) => {
  return resourceType.replace(/([A-Z])/g, ' $1').trim();
};
